import React from "react";
import { ShieldCheck, Clock, AlertCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type VerificationStatus = "verified" | "pending" | "unverified";

interface VerificationBadgeProps {
  status: VerificationStatus | string;
  size?: "small" | "medium";
  showIcon?: boolean;
  className?: string;
}

const STATUS_CONFIG: Record<
  string,
  {
    label: string;
    variant: "success" | "warning" | "muted";
    lucideIcon: React.ElementType;
  }
> = {
  verified: {
    label: "Verified",
    variant: "success",
    lucideIcon: ShieldCheck,
  },
  pending: {
    label: "Pending Review",
    variant: "warning",
    lucideIcon: Clock,
  },
  unverified: {
    label: "Unverified",
    variant: "muted",
    lucideIcon: AlertCircle,
  },
};

export function VerificationBadge({
  status,
  size = "small",
  showIcon = true,
  className,
}: VerificationBadgeProps) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG["unverified"];
  const Icon = config.lucideIcon;

  return (
    <Badge
      variant={config.variant}
      className={cn(size === "medium" && "px-2 py-0.5 text-[13px] [&_svg]:size-3.5", className)}
    >
      {showIcon && <Icon aria-hidden />}
      {config.label}
    </Badge>
  );
}
